// extracted by css-extract-rspack-plugin
export default {"ModalHeader":"puOVY","ModalBody":"JLrOD","ModalFooter":"CGYv3"};